import React, { useMemo } from 'react';

import cx from 'classnames';
import { useHistory } from 'react-router';

import ItemLink from 'components/Layouts/Admin/Dashboard/Navigation/ItemLink';
import s from 'components/shared/ActionButtons/index.module.css';
import Left from 'components/shared/Icon/icons/Left';
import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import Button from '../../../../../shared/Button';
import styles from './index.module.css';

function BackLink(props) {
  const { href, children, isButton, onClick, disabled, id, className, isSSR = false } = props;
  const history = useHistory();
  const historyState = history.location.state || {};
  const memoizedHistoryState = useMemo(() => ({ ...historyState }), []);
  const { isMobile } = useMediaBreakpoints();
  const text = isMobile ? null : children;

  return (
    <>
      <ItemLink
        href={memoizedHistoryState.libType ? memoizedHistoryState.from : href}
        noMargin
        className={styles.back}
        linkClassName={cx(styles.link, className)}
        isButton={isButton}
        onClick={onClick}
        disabled={disabled}
        id={id}
        noUnderline
        isSSR={isSSR}
      >
        <Button size="extraSmall" type="grey" shape="circle" icon={Left} className={cx(s.icon, styles.backButton)}>
          {null}
        </Button>
        {text}
      </ItemLink>
    </>
  );
}

export default BackLink;
